/* ActivityViewComponent.js */

"use strict";
const _ = require("lodash");
const ActivityTypeColumn = require("./column_renderers/activity_type/ActivityTypeComponent");
const SnapshotColumn = require("./column_renderers/snapshot/SnapshotComponent");
const DescriptionColumn = require("./column_renderers/description/DescriptionComponent");
const StatusColumn = require("./column_renderers/status/StatusComponent");
const ActionsColumn = require("./column_renderers/actions/ActionsComponent");
const BaseActivityViewComponent = require("../../../../lib/activity/BaseActivityViewComponent");

const Renderer = require("./ActivityViewRenderer");
const uString = require("underscore.string");

const PagingActivityFeed = require("./PagingActivityFeed");

_.mixin(uString.exports());

class ActivityViewComponent extends BaseActivityViewComponent {
    constructor(logger, gameEditor, io, utils, userSession, solutionsManager, storageFactory) {
        super(logger, gameEditor, io, utils, userSession, solutionsManager, storageFactory);

        this.columnConfig = {
            activityType: {
                label: "Type",
                columnRendererComponent: ActivityTypeColumn,
                entityColumn: true,
                sortable: false,
                resizable: false,
                width: 50,
                priority: 1
            },
            snapshot: {
                sort: "desc",
                label: "Activity On",
                entityColumn: true,
                columnRendererComponent: SnapshotColumn,
                sortable: true,
                width: 170,
                priority: 2
            },
            description: {
                label: "Description",
                entityColumn: true,
                columnRendererComponent: DescriptionColumn,
                sortable: false,
                width: 300,
                priority: 3
            },
            status: {
                label: "Status",
                entityColumn: true,
                columnRendererComponent: StatusColumn,
                sortable: true,
                width: 60,
                priority: 4
            },
            actions: {
                label: "",
                columnRendererComponent: ActionsColumn,
                shown: true,
                entityColumn: true,
                sortable: false,
                resizable: false,
                width: 50,
                priority: 5
            }
        };

        this._renderer = new Renderer(this);
    }

    get logger() {
        return this._logger;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _patchSorting(sorting) {
        let patchedSorting = _.clone(sorting);
        if (sorting && Object.keys(sorting).length === 1) {
            switch (true) {
                case sorting.hasOwnProperty("snapshot"):
                    patchedSorting.createdOn = sorting.snapshot;
                    delete patchedSorting.snapshot;
                    break;
                case sorting.hasOwnProperty("status"):
                    patchedSorting.jobStatus = sorting.status;
                    patchedSorting.createdOn = -1;
                    break;
            }
        } else {
            patchedSorting.createdOn = -1;
        }
        return patchedSorting;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    shutdown() {
        return Promise.all([_.invoke(this._activityFeed, "shutdown")])
            .then(() => super.shutdown())
            .then(() => {
                this._renderer = undefined;
                this.columnConfig = undefined;
            })
            .catch((err) => this._logger.warn({ error: err }, "ActivityViewComponent.shutdown() error."));
    }

    whenModelIsReady() {
        const userSorting = this._userGridData.getSorting() || {};
        const patchedSort = this._patchSorting(userSorting);
        this._entity = this._gameEditor._osCatalog;
        this._activityFeed = new PagingActivityFeed({
            feedKey: this._gridKey + "_feed",
            userSession: this._userSession,
            entityDef: this._entity,
            pageSize: 20,
            columnConfig: this.columnConfig,
            additionalDataFields: [
                "createdOn",
                "createdBy",
                "patch",
                "jobId",
                "jobTypeName",
                "jobStatus",
                "error",
                "rEntityId",
                "rEntityType",
                "relName"
            ],
            sort: patchedSort
        });
        this._registerListeners();
        return this._activityFeed.whenFeedReady();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ActivityViewComponent;

ActivityViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.io",
    "$teve.utils",
    "$teve.userSession",
    "$teve.solutionsManager",
    "$teve.storageFactory"
];

ActivityViewComponent.$displayDetails = {
    type: "View",
    name: "Activities",
    icon: "configdrift.activity",
    shown: true,
    title: "Activities",
    order: 7
};
